// Helpers for the project-grouped notification list — shared by web and mobile
// so both render identical clusters. Mirrors the groupMyTasksByProject pattern,
// except the grouping itself happens in Postgres (a project's older
// notifications sit arbitrarily deep in history, so the client never sees
// enough rows to group correctly on its own).
import { GENERAL_NOTIFICATION_GROUP_LABEL } from './notification-display.js';
/** Stable identity for a group, collapsing the project-less bucket onto one key. */
export function notificationGroupKey(group) {
    return group.projectId ?? 'general';
}
/** Header label for a group. */
export function notificationGroupTitle(group) {
    return group.projectName ?? GENERAL_NOTIFICATION_GROUP_LABEL;
}
/**
 * Flattens the infinite query's pages into one ordered list of groups.
 *
 * Dedupes on the way, keeping the first occurrence: a notification arriving
 * while page 2 is already loaded lifts its project to the top of page 1, and
 * the same project would otherwise render twice. First-wins is the right side
 * to keep — it holds the freshly-bumped copy, which carries the newer
 * lastActivityAt and preview.
 */
export function flattenNotificationGroupPages(pages) {
    const seen = new Set();
    const groups = [];
    for (const page of pages) {
        for (const group of page?.groups ?? []) {
            const key = notificationGroupKey(group);
            if (seen.has(key))
                continue;
            seen.add(key);
            groups.push(group);
        }
    }
    return groups;
}
/** How many notifications the "Show N more" expander would reveal. */
export function notificationGroupHiddenCount(group) {
    return Math.max(0, group.total - group.notifications.length);
}
//# sourceMappingURL=notification-groups.js.map